import { Route, Switch } from "react-router-dom";
import { Layout } from "../Common/FullWidthLayout";
import { ListDocumentUploads } from "./ListDocumentUploads";

export default () => (
  <Layout title="Files">
    <Switch>
      <Route path="/files" component={ListDocumentUploads} />
    </Switch>
  </Layout>
);
